import { FormattedMessage } from 'react-intl';
import Button from './core/Button';
import { IconUnlock } from '@/icons';

interface Props {
  onClickButton: () => void;
}

export const UnlockButton = ({ onClickButton }: Props) => {
  return (
    <Button startIcon={<IconUnlock />} variant="ghost" onClick={onClickButton}>
      <FormattedMessage defaultMessage="Lås upp" />
    </Button>
  );
};
